export type NetworkTrackingCallback = (info: {
  done: number
  total: number
}) => void

export type NetworkProgress = {
  download?: NetworkTrackingCallback
  upload?: NetworkTrackingCallback
}
